// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Landing-module__landing-kmdOx {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  background-color: var(--mantine-color-dark-8);
}

.nightbot-Landing-module__navBar-wta7D {
  position: fixed;
  top: 0;
  z-index: 9999;
}

.nightbot-Landing-module__divider-OtNDf {
  width: 100%;
  border-color: var(--mantine-color-gray-10);
}

.nightbot-Landing-module__featurePanels-_qQHB, .nightbot-Landing-module__infoPanels-JzFuu, .nightbot-Landing-module__appPreview-TMTS0, .nightbot-Landing-module__brandCarouselContainer-fLj0y {
  margin-bottom: 164px;
  width: 100%;
}

@media (max-width: 768px) {
  .nightbot-Landing-module__appPreview-TMTS0 {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Landing.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,aAAa;AACf;;AAEA;EACE,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".landing {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  width: 100%;\n  background-color: var(--mantine-color-dark-8);\n}\n\n.navBar {\n  position: fixed;\n  top: 0;\n  z-index: 9999;\n}\n\n.divider {\n  width: 100%;\n  border-color: var(--mantine-color-gray-10);\n}\n\n.featurePanels, .infoPanels, .appPreview, .brandCarouselContainer {\n  margin-bottom: 164px;\n  width: 100%;\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n  .appPreview {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"landing": `nightbot-Landing-module__landing-kmdOx`,
	"navBar": `nightbot-Landing-module__navBar-wta7D`,
	"divider": `nightbot-Landing-module__divider-OtNDf`,
	"featurePanels": `nightbot-Landing-module__featurePanels-_qQHB`,
	"infoPanels": `nightbot-Landing-module__infoPanels-JzFuu`,
	"appPreview": `nightbot-Landing-module__appPreview-TMTS0`,
	"brandCarouselContainer": `nightbot-Landing-module__brandCarouselContainer-fLj0y`
};
export default ___CSS_LOADER_EXPORT___;
